export default "__VITE_ASSET__DctuSX8A__"